import React from "react";
import { Svg } from "../componet/Form/style";

function Icon() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 14"
      user="true"
    >
      <path
        stroke="#CE6C80"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.28"
        d="M11.112 13.112v-1.28a2.56 2.56 0 00-2.56-2.559H3.436a2.559 2.559 0 00-2.56 2.56v1.279M5.994 6.714a2.559 2.559 0 100-5.118 2.559 2.559 0 000 5.118z"
      ></path>
    </Svg>
  );
}

export default Icon;
